import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { Skeleton } from "@mui/material";

import {
  RobotoLinkHoverUnderline,
  RobotoTypography,
} from "@/shared/components";
import { EventRecord } from "@/shared/domain/events";
import { useFile } from "@/shared/domain/files/hooks/useFile";
import { SearchParams } from "@/shared/environment";
import { nanoSecToSecStr } from "@/shared/time";

import styles from "./Scopes.module.css";

interface AssociatedFileProps {
  fileId: string;
  event: EventRecord;
}

export function AssociatedFile({ fileId, event }: AssociatedFileProps) {
  const fileQuery = useFile(fileId);
  if (fileQuery.isPending) {
    return <Skeleton variant="text" width="150px" />;
  }
  if (fileQuery.isError) {
    return (
      <span className={styles.container}>
        <ErrorOutlineIcon color="error" className={styles.icon} />
        <RobotoTypography component={"span"} className={styles.text}>
          Failed to load file
        </RobotoTypography>
      </span>
    );
  }
  return (
    <span className={styles.container}>
      <InsertDriveFileOutlinedIcon className={styles.icon} />
      <RobotoLinkHoverUnderline
        to={`/files/${fileId}?${SearchParams.TIMESTAMP}=${nanoSecToSecStr(event.start_time)}`}
        className={styles.text}
        title={fileQuery.data?.relative_path}
      >
        {fileQuery.data?.relative_path}
      </RobotoLinkHoverUnderline>
    </span>
  );
}
